
'use client';

import Link from "next/link";
import { Logo } from "@/components/logo";
import Image from "next/image";
import { useBookDemo } from "@/context/schedule-demo-context";

export default function Footer() {
  // Scrolls to this page's contact section, or goes to /contact when there is none.
  const handleContactClick = useBookDemo();

  return (
    <footer role="contentinfo" className="bg-background text-muted-foreground border-t">
      <div className="container mx-auto px-4 md:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 mb-8">
          <div className="flex-shrink-0">
            <Link href="/" className="inline-flex rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              <Logo />
            </Link>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
            <Link href="/#features" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              How It Works
            </Link>
            <Link href="/audit-transparency" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              Audit Module
            </Link>
            <Link href="/em-coding" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              E/M Coding
            </Link>
            <Link href="/blog" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              Blog
            </Link>
            <a href="https://uptime.medchartscan.io/status/app" target="_blank" rel="noopener noreferrer" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              Status
            </a>
            <button onClick={handleContactClick} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors">
              Contact
            </button>
          </nav>
          <div className="flex items-center justify-center gap-x-1">
            <a href="https://x.com/medchartscan" target="_blank" rel="noopener noreferrer" aria-label="Follow us on X" className="flex items-center p-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground h-10 w-10 justify-center">
              <Image src="/x-logo.svg" alt="Follow us on X" width={16} height={16} className="h-4 w-4 dark:invert" />
            </a>
          </div>
        </div>
        <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left text-xs text-muted-foreground/80">
              <span>&copy; 2026 MedChartScan Inc. All rights reserved.</span>
              <Link href="/about" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors ml-4">About</Link>
              <Link href="/contact" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors ml-4">Contact</Link>
              <Link href="/privacy-policy" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors ml-4">Privacy Policy</Link>
              <Link href="/terms" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors ml-4">Terms of Service</Link>
              <Link href="/sms-terms" className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:text-foreground transition-colors ml-4">SMS Terms</Link>
            </div>
            <div className="flex items-center gap-4">
                 <div title="Amazon Web Services">
                    <Image src="/Amazon_Web_Services_Logo.svg" alt="Amazon Web Services" width={24} height={24} className="h-5 w-auto opacity-60 dark:invert" />
                </div>
                <div title="Elasticsearch">
                    <Image src="/elasticsearch.svg" alt="Elasticsearch" width={24} height={24} className="h-5 w-auto opacity-60 dark:invert" />
                </div>
                 <div title="Google Cloud Platform">
                    <Image src="/Google_Cloud_logo.svg" alt="Google Cloud Platform" width={24} height={24} className="h-5 w-auto opacity-60 dark:invert" />
                </div>
                 <div title="Microsoft Azure">
                    <Image src="/Microsoft_Azure_Logo.svg" alt="Microsoft Azure" width={24} height={24} className="h-5 w-auto opacity-60 dark:invert" />
                </div>
            </div>
        </div>
      </div>
    </footer>
  );
}
